export { default } from './withWorkRecommendations';
export * from './withWorkRecommendations';
